export enum CustomEventId {
    GTMDomReady = 'gtm.dom',
    GTMDomLoaded = 'gtm.load',
    ArtistSubscription = 'artist-subscription',
    Logout = 'logout',
    ConsentManagerLoaded = 'cmpEventLoadFinished',
}
